









import { Component, Vue, Provide, Prop } from 'vue-property-decorator';

interface event {
    title: string;
    content: string;
}

@Component({})
export default class DataList extends Vue {
    @Prop() public stage!: event[];

    get Stage() {
        return this.stage;
    }
}
